import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
import { SystemSuggestionPayloadSchema, OrgFunctionSuggestionPayloadSchema, EntitySuggestionSchema } from '../../entities/entity-suggestion';
const ApproveSystem = z.object({
    kind: z.literal('system'),
    // admin-edited payload — systemOwner is required here even if optional in the persisted schema
    payload: SystemSuggestionPayloadSchema.extend({
        systemOwner: z.string().min(1, ErrorCode.FIELD_REQUIRED)
    })
});
// Approving creates a OrgFunction of the payload's `kind`. `department`/`lead`
// stay optional (a role or a dept-less team is valid), so the approve payload
// is the persisted payload as-is — the admin edits it in the review form.
const ApproveOrgFunction = z.object({
    kind: z.literal('orgFunction'),
    payload: OrgFunctionSuggestionPayloadSchema
});
export const ApproveEntitySuggestionRequestSchema = z.discriminatedUnion('kind', [
    ApproveSystem,
    ApproveOrgFunction
]);
export const ApproveEntitySuggestionResponseSchema = z.object({
    data: EntitySuggestionSchema
});

//# sourceMappingURL=approve-entity-suggestion.contract.js.map